document.addEventListener('DOMContentLoaded', function () {
  const forms = document.querySelectorAll('.js-search-field-wrapper');

  forms.forEach(function (form) {
    const input = form.querySelector('.js-search-form__input');
    const clearBtn = form.querySelector('.js-search-form__clear');

    if (!input || !clearBtn) return;

    clearBtn.addEventListener('click', function () {
      input.value = '';
      input.focus();
    });
  });
});